<template>
  <b-modal
    id="modal-nuevo-pago"
    centered
    title="Detalles"
    cancel-variant="outline-secondary"
    v-model="$store.state.someVariables.showNewAuxiliar"
    size="lg"
  >
    <h4 style="margin-bottom:10px">
      {{ listEquipos.disciplina }} {{ listEquipos.categoria }}
    </h4>
    <div style="margin:30px" v-if="auxiliar == '1'">
      <b-row
        style="border-bottom:1px solid gray;padding:4px"
        v-for="item in listEquipos.equipos"
        :key="item.id"
      >
        <b-col class="text-left" md="4">{{ item.local }}</b-col>
        <b-col md="4" class="text-right">
          <b>{{ item.total_calificados }}</b></b-col
        >
      </b-row>
    </div>
    <div style="margin:30px" v-if="auxiliar == '2'">
      <b-row style="border-bottom:1px solid gray;padding:4px">
        <b-col style="font-weight: bold" class="text-left" md="4">
          Semanas Programadas
        </b-col>
        <b-col style="font-weight: bold" md="2" class="text-right">
          Finalizados</b-col
        >
        <b-col style="font-weight: bold" md="2" class="text-right">
          Pendientes</b-col
        >
        <b-col style="font-weight: bold" md="2" class="text-right">
          Total</b-col
        >
        <b-col style="font-weight: bold" md="2" class="text-right">
          Valor</b-col
        >
      </b-row>
      <div style="max-height:60vh;overflow:scroll">
        <b-row
          style="border-bottom:1px solid gray;padding:4px; "
          v-for="item in listEquipos.semanas_datos"
          :key="item.id"
        >
          <b-col class="text-left" md="4">
            <span style="font-size:13px;font-weight: bold"
              >semana {{ item.semana }}</span
            ><br />
            <span style="font-size:12px; color:gray"
              >del {{ item.fecha_inicial }} al {{ item.fecha_final }}</span
            >
          </b-col>
          <b-col
            style="font-size:16px;font-weight: bold"
            md="2"
            class="text-right"
          >
            {{ item.jugados }}</b-col
          >
          <b-col
            style="font-size:16px;font-weight: bold"
            md="2"
            class="text-right"
          >
            {{ item.pendientes }}</b-col
          >
          <b-col
            style="font-size:16px;font-weight: bold"
            md="2"
            class="text-right"
          >
            {{ item.expectativa }}</b-col
          >
          <b-col
            style="font-size:16px;font-weight: bold"
            md="2"
            class="text-right"
          >
            {{ item.expectativa * listEquipos.valor }} $
          </b-col>
        </b-row>
      </div>
    </div>
    <template #modal-footer>
      <div style="justify-content:start; width:100%"></div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BRow, BCol } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
  },
  props: {
    listEquipos: Object,
    auxiliar: String,
  },
  setup() {},
}
</script>
